import axios from "axios";
import * as config from "../../config";
import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetAllGDORMasterDetailwithPagging = async (
  pageNum,
  pageSize,
  search
) => {
  const token = localStorage.getItem("token");
  let url;
  if (search) {
    url = `/api/ACG_GDORMasterDetail/GetAllGDORMasterDetailwithPagging?PageNumber=${
      pageNum + 1
    }&PageSize=${pageSize}&Search=${search}`;
  } else {
    url = `/api/ACG_GDORMasterDetail/GetAllGDORMasterDetailwithPagging?PageNumber=${
      pageNum + 1
    }&PageSize=${pageSize}`;
  }
  let res = await Services.GET(url, token);
  return res;
};

export const AddGDORMasterDetail = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_GDOR_MASTER_DETAIL, payload, token);
  return res;
};

export const UpdateGDORMasterDetail = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_GDOR_MASTER_DETAIL, payload, token);
  return res;
};

export const DeleteGDORMasterDetail = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_GDOR_MASTER_DETAIL + id,
    id,
    token
  );
  return res;
};
